import { useState, useEffect } from 'react';

/**
 * useState that automatically persists to sessionStorage.
 * Values are JSON-serialized, so keep them JSON-compatible.
 * sessionStorage is cleared when the browser tab closes.
 */
export function usePersistedState(key, defaultValue) {
    const [state, setState] = useState(() => {
        try {
            const saved = sessionStorage.getItem(key);
            return saved !== null ? JSON.parse(saved) : defaultValue;
        } catch {
            return defaultValue;
        }
    });

    useEffect(() => {
        try {
            sessionStorage.setItem(key, JSON.stringify(state));
        } catch {}
    }, [key, state]);

    return [state, setState];
}
